import React, {useState} from 'react'

function SaveModal({ isOpen, setIsOpen, onSave, name , setName }) {

  return (
      <div className={isOpen ? 'fixed z-10 inset-0 overflow-y-auto' : 'hidden'}>
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
              <div className="fixed inset-0 transition-opacity" aria-hidden="true">
                  <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
              </div>
              <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
              <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                          <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                              <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                                  Save your code
                              </h3>
                              <div className="mt-2">
                                  <p className="text-sm text-gray-500">
                                      Enter a name for your code snippet
                                  </p>
                                  <input
                                      type="text"
                                      className="mt-2 w-full border border-gray-300 p-2 rounded-md"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                  />
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                      <button
                          type="button"
                          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"
                          onClick={() => {
                              onSave(name)
                              setIsOpen(false)
                          }}
                      >
                          Save
                      </button>
                      <button
                          type="button"
                          className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                          onClick={() => setIsOpen(false)}
                      >
                          Cancel
                      </button>
                  </div>
              </div>
          </div>
      </div>
      

                                 
                                  
  )
}

export default SaveModal